import { Injectable } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database-deprecated';
import { AngularFireAuth } from 'angularfire2/auth';

@Injectable()
export class FirebaseYasoService {
  public messages: FirebaseListObservable<any>;
  public users: FirebaseListObservable<any>;
  public displayName: string;
  public email: string;

  constructor(public af: AngularFireDatabase, public angularfire: AngularFireAuth) {
    this.messages = this.af.list('messages');
   }

  /**
   * Logs out the current user
   */

  logout() {
    this.angularfire.auth.signOut();
  }
  /**
   * Saves a message to the Firebase Realtime Database
   * @param text
   */
  sendMessage(text) {
    // tslint:disable-next-line:prefer-const
    let message = {
      message: text,
      displayName: this.displayName,
      email: this.email,
      timestamp: Date.now()
    };
    this.messages.push(message);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/firebase-yaso.service.ts